<template>
  <teleport to="body">
    <div @click="dialogVisible = false" class="dialog-box" v-if="dialogVisible">
      <div @click.stop="" class="dialog-contnet">
        <h2 class="mb-[12px]">{{ $t("dialog.text4") }}</h2>

        <p class="mb-[12px]">{{ $t("dialog.text5") }}</p>

        <div v-copy="extensionUrl" class="link mb-[12px]">{{ extensionUrl }}</div>

        <div @click.stop="dialogVisible = false" class="button">
          <span>{{ $t("dialog.text6") }}</span>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { watch } from "vue";
import { CircleCheckFilled } from "@element-plus/icons-vue";
import { useGetLanguage } from "@/hooks/useGetLanguage";

const { extensionUrl } = useGetLanguage();
const dialogVisible = defineModel();

function preventScroll(e: any) {
  e.preventDefault();
  e.stopPropagation();
  return false;
}

watch(
  dialogVisible,
  (val) => {
    if (val) {
      document.addEventListener("wheel", preventScroll, { passive: false });
    } else {
      document.removeEventListener("wheel", preventScroll);
    }
  },
  {
    immediate: true,
  }
);
</script>

<style scoped lang="scss">
.dialog-box {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .dialog-contnet {
    width: 460px;
    background-color: #fff;
    border-radius: 16px 16px 16px 16px;
    padding: 36px;

    h2 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #1d212d;
    }
    > p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #667085;
      margin-top: 12px;
    }

    .info {
      margin: auto;
      img {
        width: 160px;
        height: 160px;
      }
    }

    .link {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #7815f5;
      text-decoration-line: underline;
      word-wrap: break-word;
    }

    .button {
      width: 100%;
      text-align: right;
      overflow: hidden;
      span {
        display: inline-block;
        width: max-content;
        float: right;
        height: 44px;
        padding: 7px 82px;
        border-radius: 12px 12px 12px 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        background-color: #9038ff;
        opacity: 1;
        margin-top: 40px;
      }
    }
  }
}
</style>
